import axios, {
  AxiosHeaders,
  AxiosRequestConfig,
  RawAxiosRequestHeaders,
} from 'axios'

// Server URL
const serverUrl = process.env.REACT_APP_SERVER_URL

// Creating a New Axios Instance
const axiosInstance = axios.create({
  baseURL: serverUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

interface Config extends AxiosRequestConfig<any> {
  data?: any
  url: string
}

interface HeaderConfig extends AxiosRequestConfig<any> {
  headers: RawAxiosRequestHeaders | AxiosHeaders
}

export default class Api {
  //* For POST Request
  static async post(config: Config) {
    const { data, url, headers = {}, ...restConfig } = config
    const postConfig: HeaderConfig = {
      headers: {
        ...axiosInstance.defaults.headers,
        ...headers,
      },
      ...restConfig,
    }
    return axiosInstance.post(url, data, postConfig)
  }

  //* For GET Request
  static async get(config: Config) {
    const { url, ...restConfig } = config
    const getConfig = {
      ...restConfig,
    }
    return axiosInstance.get(url, getConfig)
  }

  //* For PUT Request
  static async put(config: Config) {
    const { data, url, headers = {}, ...restConfig } = config
    const putConfig: HeaderConfig = {
      headers: {
        ...axiosInstance.defaults.headers,
        ...headers,
      },
      ...restConfig,
    }
    return axiosInstance.put(url, data, putConfig)
  }

  //* For PATCH Request
  static async patch(config: Config) {
    const { data, url, headers = {}, ...restConfig } = config
    const putConfig: HeaderConfig = {
      headers: {
        ...axiosInstance.defaults.headers,
        ...headers,
      },
      ...restConfig,
    }
    return axiosInstance.patch(url, data, putConfig)
  }

  //* For DELETE Request
  static async delete(config: Config) {
    const { url, headers = {}, ...restConfig } = config

    /** Post Header Configuration */
    const deleteConfig: HeaderConfig = {
      headers: { ...axiosInstance.defaults.headers, ...headers },
      ...restConfig,
    }

    return axiosInstance.delete(url, deleteConfig)
  }
}
